export const LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/bay7h7k6_Screenshot_20260908_123247.jpg";

export const POSTERS = {
  pricing:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/47yjroq9_file_000000000ca481f9ae79c29513d35446.png",
  erp:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/ty785gaa_file_00000000219481f4a484d7944a2a46cf.png",
  marketplace:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/c5k4wqzb_file_0000000000d882099dbb3c85b814a2b0.png",
  director:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/kt4sv76m_file_000000009798821192dbd1132163f62b.png",
  sat2farm:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/ywm4sgxd_Screenshot_20260909_124940_com_hihonor_photos_GalleryMain.jpg",
  director2:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/54thqttl_file_00000000d56081fa9a5f5f2b3c973801.png",
};

export const MARKETPLACE_VIDEO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_kmg-marketplace-hub/artifacts/cazujouy_586fbc87da3c4a37991620d10607a76f_kmg_digi_marketplace_60s.mp4";

export const COLLATERAL = [
  { id: "erp", title: "KMG Digi Platform — Digital ERP for Agriculture", src: POSTERS.erp },
  { id: "marketplace", title: "The KMG Digi Marketplace", src: POSTERS.marketplace },
  { id: "pricing", title: "Pricing Plans & Mobile App", src: POSTERS.pricing },
  { id: "sat2farm", title: "KMG Digi × Sat2Farm Partnership", src: POSTERS.sat2farm },
  { id: "director", title: "Leadership — Morena Mofokeng", src: POSTERS.director },
  { id: "director2", title: "Leadership — Khethiwe Mary Gumede", src: POSTERS.director2 },
];

export const IMAGES = {
  heroField:
    "https://images.unsplash.com/photo-1511802269876-bf873cc7b2c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxncmVlbiUyMGFncmljdWx0dXJlJTIwZmllbGQlMjBkcm9uZSUyMHNtYXJ0JTIwZmFybWluZyUyMGFlcmlhbCUyMHZpZXd8ZW58MHx8fHwxNzg5MTIwMDQ3fDA&ixlib=rb-4.1.0&q=85",
  aerial:
    "https://images.unsplash.com/photo-1516822277566-bb38424a2b77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxncmVlbiUyMGFncmljdWx0dXJlJTIwZmllbGQlMjBkcm9uZSUyMHNtYXJ0JTIwZmFybWluZyUyMGFlcmlhbCUyMHZpZXd8ZW58MHx8fHwxNzg5MTIwMDQ3fDA&ixlib=rb-4.1.0&q=85",
  maize:
    "https://images.unsplash.com/photo-1777061209408-d7add6e62087?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwZmFybWVyJTIwaGFydmVzdCUyMG1haXplJTIwZmllbGR8ZW58MHx8fHwxNzg5MTIwMDgxfDA&ixlib=rb-4.1.0&q=85",
  wheat:
    "https://images.unsplash.com/photo-1573017714908-ab59396f5f01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwZmFybWVyJTIwaGFydmVzdCUyMG1haXplJTIwZmllbGR8ZW58MHx8fHwxNzg5MTIwMDgxfDA&ixlib=rb-4.1.0&q=85",
  tractor:
    "https://images.unsplash.com/photo-1756157056818-60a81a6245de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwZmFybWVyJTIwaGFydmVzdCUyMG1haXplJTIwZmllbGR8ZW58MHx8fHwxNzg5MTIwMDgxfDA&ixlib=rb-4.1.0&q=85",
  crateLettuce:
    "https://images.unsplash.com/photo-1751210769268-85d43ecfcdd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGZhcm0lMjBwcm9kdWNlJTIwdmVnZXRhYmxlcyUyMGNyYXRlfGVufDB8fHx8MTc4OTEyMDA4MXww&ixlib=rb-4.1.0&q=85",
  cratePeppers:
    "https://images.unsplash.com/photo-1769181463790-0c5a2a8fea69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxmcmVzaCUyMGZhcm0lMjBwcm9kdWNlJTIwdmVnZXRhYmxlcyUyMGNyYXRlfGVufDB8fHx8MTc4OTEyMDA4MXww&ixlib=rb-4.1.0&q=85",
  basket:
    "https://images.unsplash.com/photo-1657288089316-c0350003ca49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMGZhcm0lMjBwcm9kdWNlJTIwdmVnZXRhYmxlcyUyMGNyYXRlfGVufDB8fHx8MTc4OTEyMDA4MXww&ixlib=rb-4.1.0&q=85",
  apples:
    "https://images.unsplash.com/photo-1785076315182-98f6751997ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMGZhcm0lMjBwcm9kdWNlJTIwdmVnZXRhYmxlcyUyMGNyYXRlfGVufDB8fHx8MTc4OTEyMDA4MXww&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Platform", href: "#platform" },
  { label: "Marketplace", href: "#marketplace" },
  { label: "Sat2Farm", href: "#sat2farm" },
  { label: "Pricing", href: "#pricing" },
  { label: "Leadership", href: "#leadership" },
  { label: "Partners", href: "#partners" },
  { label: "Media", href: "#media" },
  { label: "Contact", href: "#contact" },
];

export const PILLARS = [
  { icon: "Cloud", title: "Cloud-Native", body: "Secure. Scalable. Reliable." },
  { icon: "MonitorSmartphone", title: "Mobile & Desktop", body: "Any device. Anywhere." },
  { icon: "TrendingUp", title: "Real-Time Insights", body: "Data-driven decisions." },
  { icon: "Settings", title: "Smart Automation", body: "Less manual work." },
  { icon: "ShieldCheck", title: "Secure & Compliant", body: "Enterprise-grade security." },
  { icon: "Sprout", title: "Built for Farmers", body: "Designed to help you grow." },
];

export const FEATURES = [
  {
    icon: "Leaf",
    title: "Farm & Crop Management",
    items: [
      "Crop planning & production scheduling",
      "Planting and harvesting records",
      "Field & farm activity monitoring",
      "Input usage tracking",
      "Production forecasting & yield monitoring",
    ],
  },
  {
    icon: "Beef",
    title: "Livestock Management",
    items: [
      "Poultry, pigs, goats, sheep & cattle records",
      "Animal numbers & movement",
      "Feeding and health records",
      "Production monitoring",
      "Livestock performance reporting",
    ],
  },
  {
    icon: "Warehouse",
    title: "Inventory & Procurement",
    items: [
      "Seeds, fertiliser & agricultural inputs",
      "Stock-level monitoring",
      "Supplier management",
      "Purchase orders",
      "Inventory movement & traceability",
    ],
  },
  {
    icon: "Coins",
    title: "Financial Management",
    items: [
      "Farm income and expenses",
      "Budgets and financial reporting",
      "Cost-per-production analysis",
      "Cash-flow visibility",
      "Financial performance dashboards",
    ],
  },
  {
    icon: "Truck",
    title: "Supply Chain & Logistics",
    items: [
      "Orders and deliveries",
      "Supplier-to-farm tracking",
      "Farm-to-market traceability",
      "Distribution management",
      "Delivery scheduling",
    ],
  },
  {
    icon: "BarChart3",
    title: "Business Intelligence",
    items: [
      "Real-time management dashboards",
      "Management reports",
      "Production analytics",
      "Performance indicators",
      "Data-driven decision-making",
    ],
  },
  {
    icon: "Landmark",
    title: "Digital Finance & Funding",
    items: [
      "Digital farmer onboarding",
      "Financial profiles",
      "Transaction data insights",
      "Funding opportunities",
      "Subject to financier approval",
    ],
  },
  {
    icon: "Sun",
    title: "Solar & Irrigation Systems",
    items: [
      "Solar system monitoring & performance",
      "Water usage and irrigation scheduling",
      "Pump and borehole management",
      "Energy and water cost tracking",
      "Sustainable and efficient resource use",
    ],
  },
];

export const FARMER_BENEFITS = [
  { icon: "Globe", title: "Wider Market Access", body: "Reach more retailers, restaurants and buyers beyond your local area." },
  { icon: "HandCoins", title: "Fair Pricing", body: "Set your prices, negotiate and get the best value." },
  { icon: "TrendingUp", title: "Increased Sales", body: "Sell more, more often and grow your business." },
  { icon: "Leaf", title: "Reduced Waste", body: "Plan better and sell faster with real-time demand." },
  { icon: "Smartphone", title: "Easy to Use", body: "List products, manage orders and track sales with ease." },
  { icon: "ShieldCheck", title: "Get Paid Securely", body: "Safe and transparent payment processes." },
];

export const RETAILER_BENEFITS = [
  { icon: "Truck", title: "Reliable Supply", body: "Source fresh, quality produce from verified farmers." },
  { icon: "Salad", title: "Wide Variety", body: "Access a wide range of products in one place." },
  { icon: "Percent", title: "Competitive Prices", body: "Compare, negotiate and get the best prices." },
  { icon: "Clock", title: "Convenience", body: "Order anytime, anywhere and get timely delivery." },
  { icon: "Search", title: "Transparency", body: "See product origin, quality and farmer profiles." },
  { icon: "Handshake", title: "Build Relationships", body: "Build long-term relationships with trusted farmers." },
];

export const HOW_IT_WORKS = [
  { n: "1", title: "Sign Up", body: "Farmers and retailers create their free accounts." },
  { n: "2", title: "List & Browse", body: "Farmers list their products. Retailers browse and compare." },
  { n: "3", title: "Order & Negotiate", body: "Place orders, negotiate prices and confirm agreements." },
  { n: "4", title: "Deliver", body: "Products are delivered safely and on time to retailers." },
  { n: "5", title: "Pay Securely", body: "Payments are processed securely and fairly for all." },
];

export const WHY_MARKETPLACE = [
  { icon: "LayoutGrid", title: "All-in-One Digital Platform", body: "Manage everything in one place." },
  { icon: "Lock", title: "Secure & Reliable", body: "Safe, secure and built on trusted technology." },
  { icon: "LineChart", title: "Data-Driven Insights", body: "Make smarter decisions with real-time data." },
  { icon: "Sprout", title: "Support Local Farmers", body: "Grow local. Grow our economy." },
  { icon: "Headphones", title: "Dedicated Support", body: "We're here to help you thrive." },
];

export const PRODUCT_CATEGORIES = [
  { id: "vegetables", name: "Vegetables", image: IMAGES.basket },
  { id: "fruits", name: "Fruits", image: IMAGES.apples },
  { id: "livestock", name: "Livestock", image: IMAGES.tractor },
  { id: "grains", name: "Grains & More", image: IMAGES.maize },
];

export const TESTIMONIALS = [
  { quote: "KMG Digi helped me find more customers and sell all my produce on time.", author: "Happy Farmer" },
  { quote: "The KMG Digi Platform makes buying easier, faster and more reliable.", author: "Happy Retailer" },
];

export const SAT2FARM_BENEFITS = [
  { icon: "Satellite", title: "Real-Time Crop Monitoring", body: "Track crop health, growth and field conditions using satellite data." },
  { icon: "Sprout", title: "Soil Health Insights", body: "Understand soil variability and improve soil management." },
  { icon: "PiggyBank", title: "Cost Savings", body: "Use resources more efficiently and reduce input waste." },
  { icon: "Droplets", title: "Water Management", body: "Identify water stress and optimise irrigation for better resource use." },
  { icon: "MapPin", title: "Field Mapping & Planning", body: "Get detailed maps for planting, fertiliser application and harvesting." },
  { icon: "MonitorSmartphone", title: "Access Anytime, Anywhere", body: "View your farm data on your mobile or desktop device." },
  { icon: "ShieldCheck", title: "Risk Reduction", body: "Detect pests, diseases and stress early before they spread." },
  { icon: "BarChart3", title: "Higher Productivity", body: "Make data-driven decisions and maximise your yields." },
  { icon: "Handshake", title: "Expert Support", body: "Get guidance from a team of agri-specialists and data analysts." },
];

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    for: "Small Farmers",
    monthly: "R299",
    yearly: "R2 990",
    save: "Save R598",
    blurb: "Perfect for small-scale farmers starting their digital journey.",
    cta: "Get Started",
    features: ["Farm Records", "Livestock Management", "Crop Management", "Expense Tracking", "Mobile App Access", "Basic Reports"],
  },
  {
    id: "growth",
    name: "Growth",
    for: "Medium Commercial Farmers",
    monthly: "R799",
    yearly: "R7 990",
    save: "Save R1 598",
    blurb: "Grow your farm with better management and insights.",
    cta: "Choose Growth",
    featured: true,
    inherits: "Everything in Starter, plus:",
    features: ["Inventory Management", "Staff Management", "Sales Management", "GPS Farm Mapping", "Digital Invoices", "Financial Dashboards"],
  },
  {
    id: "professional",
    name: "Professional",
    for: "Large Commercial Farms",
    monthly: "R1 499",
    yearly: "R14 990",
    save: "Save R2 998",
    blurb: "Advanced tools and automation to run your farm like a business.",
    cta: "Go Professional",
    inherits: "Everything in Growth, plus:",
    features: ["AI Insights & Analytics", "IoT & Smart Devices", "Smart Irrigation", "Equipment Management", "Loan Applications", "Multi-farm Management", "API Integrations"],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    for: "Farming Groups & Agribusinesses",
    monthly: "From R4 999",
    yearly: "From R49 990",
    save: "Save R9 998+",
    blurb: "Unlimited power, full control and custom solutions.",
    cta: "Contact Us",
    features: ["Unlimited Users & Farms", "Custom Workflows", "ERP Integrations", "Business Intelligence", "Custom Reporting", "Dedicated Support", "White-label Options"],
  },
];

export const WHY_PLATFORM = [
  { icon: "TrendingUp", title: "Increase Productivity", body: "Streamline operations and do more in less time." },
  { icon: "Coins", title: "Lower Costs", body: "Reduce manual work, wastage and operational costs." },
  { icon: "BarChart3", title: "Improve Profitability", body: "Track performance and make data-driven decisions." },
  { icon: "Landmark", title: "Access Finance Faster", body: "Apply for loans directly through our integrated finance network." },
  { icon: "ShieldCheck", title: "Secure & Reliable", body: "Your data is safe with enterprise-grade security." },
  { icon: "MonitorSmartphone", title: "Anytime, Anywhere", body: "Manage your farm from your mobile or desktop." },
];

export const DIRECTORS = [
  {
    id: "morena",
    name: "Morena Mofokeng",
    role: "Director | KMG Farm & KMG Digi Platform",
    tags: ["Business Entrepreneur", "Strategic Leader", "Digital Transformation Advocate", "MBA Candidate"],
    bio: [
      "Morena Mofokeng is a South African business entrepreneur and strategic leader with more than 20 years of professional experience. As a Director of KMG Farm and KMG Digi Platform, he is focused on building practical solutions that connect agriculture, technology, markets and access to finance.",
      "His leadership vision is to empower farmers, strengthen agricultural value chains and accelerate digital transformation across African agriculture.",
    ],
    focusLabel: "Leadership focus",
    focus: [
      { icon: "Sprout", title: "Smart Agriculture" },
      { icon: "MonitorSmartphone", title: "Digital ERP & Farm Management" },
      { icon: "Truck", title: "Farmer-to-Market Connectivity" },
      { icon: "Handshake", title: "Strategic Partnerships & Growth" },
    ],
    vision:
      "Building smarter farms, stronger agricultural ecosystems and sustainable opportunities for African farmers.",
    image: POSTERS.director,
    imageOffset: "left top",
  },
  {
    id: "khethiwe",
    name: "Khethiwe Mary Gumede",
    role: "Director | KMG Farm",
    tags: ["Passionate Farmer", "Purpose-Driven Leader", "Building Sustainable Agricultural Opportunities"],
    bio: [
      "Khethiwe Mary Gumede is a Director of KMG Farm and a passionate, purpose-driven farmer committed to building sustainable agricultural opportunities for her community.",
      "She combines formal business management training with hands-on agricultural and occupational health and safety expertise to keep KMG Farm productive, compliant and growing.",
    ],
    focusLabel: "Qualifications",
    focus: [
      { icon: "GraduationCap", title: "Business Management Degree" },
      { icon: "Leaf", title: "Agricultural Certificate" },
      { icon: "HardHat", title: "OHS Certificate" },
      { icon: "Car", title: "Code 8 Driver" },
    ],
    vision: "Growing agriculture. Empowering communities. Building a sustainable future.",
    image: POSTERS.director2,
    imageOffset: "center top",
  },
];

export const PARTNER_OPPORTUNITIES = [
  { icon: "Landmark", title: "Banks & Financial Institutions", items: ["Digital farmer onboarding", "Agricultural finance referrals", "Farmer financial profiles", "Transaction data insights", "SME & agri funding opportunities"] },
  { icon: "Sprout", title: "Agricultural Input Suppliers", items: ["Digital supplier networks", "Product catalogues", "Procurement opportunities", "Demand forecasting", "Farm input management"] },
  { icon: "ShoppingCart", title: "Retailers, Restaurants & Supermarkets", items: ["Digital ordering", "Supplier visibility", "Production planning", "Traceability", "Delivery coordination"] },
  { icon: "Tractor", title: "Agri Equipment & Technology Companies", items: ["Equipment partnerships", "Smart-farming technology", "IoT integration", "Farm automation", "Machinery management"] },
  { icon: "Users", title: "Cooperatives & Farmer Organisations", items: ["Digitise farmer records", "Monitor production", "Consolidate procurement", "Track member performance", "Management reports"] },
  { icon: "GraduationCap", title: "Training & Development Organisations", items: ["Digital farmer training", "Skills development", "Agricultural entrepreneurship", "Youth participation", "Data-driven farming"] },
];

export const WHY_PARTNER = [
  { icon: "Network", title: "Connect", body: "Bring farmers, suppliers, buyers, financiers and service providers onto one ecosystem." },
  { icon: "Workflow", title: "Digitise", body: "Replace manual processes with smart digital workflows." },
  { icon: "Eye", title: "Visualise", body: "Real-time visibility across operations and finances." },
  { icon: "Route", title: "Trace", body: "Track every step from farm to market." },
  { icon: "TrendingUp", title: "Grow", body: "Drive productivity, profitability and sustainable growth." },
];

export const PARTNER_BRANDS = ["Nedbank", "SPAR", "Wimpy", "1904 Restaurant", "Sat2Farm", "KMG Farm"];

const DEMO_VIDEO_UNUSED = null;
void DEMO_VIDEO_UNUSED;

export const FEATURED_VIDEO = {
  id: "marketplace-60s",
  title: "KMG Digi Marketplace — Connect. Trade. Grow.",
  duration: "01:00",
  poster: IMAGES.heroField,
  src: MARKETPLACE_VIDEO,
  blurb:
    "The official KMG Digi Marketplace film: how farmers and retailers meet on one digital platform to buy, sell and grow.",
};

export const VIDEOS = [FEATURED_VIDEO];

export const CONTACT = {
  headOffice: ["KMG Farm Head Office", "71 Old Main Road", "Hillcrest, Durban", "KwaZulu-Natal, South Africa"],
  headOfficePhone: "031 035 0114",
  addressLines: ["KMG Farm", "Tongaat, KwaZulu-Natal", "South Africa"],
  phones: ["061 483 6960", "068 172 0368", "031 123 4567"],
  email: "info@kmgfarm.co.za",
  website: "www.kmgfarm.co.za",
  sat2farm: ["Sat2Farm HQ", "2nd Floor, The District", "70 Somerset Road, Green Point", "Cape Town, 8001, South Africa"],
  mapEmbed: "https://www.google.com/maps?q=71+Old+Main+Road,+Hillcrest,+Durban,+South+Africa&output=embed",
  socials: [
    { name: "Facebook", icon: "Facebook", href: "https://www.facebook.com" },
    { name: "Instagram", icon: "Instagram", href: "https://www.instagram.com/kmgfarm_za" },
    { name: "TikTok", icon: "Music2", href: "https://www.tiktok.com" },
    { name: "LinkedIn", icon: "Linkedin", href: "https://www.linkedin.com" },
    { name: "YouTube", icon: "Youtube", href: "https://www.youtube.com" },
  ],
};

export const ROLES = [
  "Farmer / Producer",
  "Retailer / Restaurant / Supermarket",
  "Cooperative / Farmer Organisation",
  "Bank / Financial Institution",
  "Agricultural Input Supplier",
  "Agri Equipment / Technology Company",
  "Training & Development Organisation",
];

export const REGIONS = [
  "KwaZulu-Natal",
  "Gauteng",
  "Western Cape",
  "Eastern Cape",
  "Free State",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Outside South Africa",
];

export const PLAN_OPTIONS = ["Starter — R299/month", "Growth — R799/month", "Professional — R1 499/month", "Enterprise — from R4 999/month", "Marketplace only", "Partnership enquiry"];
